import {set} from 'lodash-es';

import {ELocationStateKey, useAppHistory} from 'shared/hooks/use-app-history';

import {ITableReportLocationDefaults} from '../table-report-types';

export const useLocationDefaultsManager = () => {
    const history = useAppHistory();

    const saveDefaultsToLocationState = (args: ITableReportLocationDefaults) => {
        const {
            locationFilters,
            locationPage,
            locationParameters,
            locationSize,
            locationSort,
            locationReportGroups,
        } = args;

        const nextBreadcrumbs = (() => {
            const currentBreadcrumbs = [
                ...history.getLocationState()?.[ELocationStateKey.TABLE_REPORT_BREADCRUMBS] ?? [],
            ];
            let breadcrumbs;
            if (currentBreadcrumbs.length) {
                const lastBreadcrumb = currentBreadcrumbs?.pop();
                if (lastBreadcrumb) set(lastBreadcrumb, ['extraData', 'tableReportLocationDefaults'], args);
                breadcrumbs = [...currentBreadcrumbs];
                if (lastBreadcrumb) breadcrumbs.push(lastBreadcrumb);
            }
            return breadcrumbs;
        })();

        history.updateLocationState({
            ...(() => {
                if (!nextBreadcrumbs) return {};
                return {[ELocationStateKey.TABLE_REPORT_BREADCRUMBS]: nextBreadcrumbs};
            })(),
            [ELocationStateKey.TABLE_REPORT_LOCATION_DEFAULTS]: {
                locationFilters,
                locationPage,
                locationParameters,
                locationSize,
                locationSort,
                locationReportGroups,
            },
        });
    };

    return {
        saveDefaultsToLocationState,
    };
};
